import { apiClient } from './client';
import { unwrapAndTransform } from '../utils/api-response';
// ---------------------------------------------------------------------------
// All snake_case → camelCase transformation now handled by unwrapAndTransform
// This consolidates 21 custom transform functions + unwrap helper into a single utility
// Code reduction: ~230 lines eliminated
// ---------------------------------------------------------------------------
const BASE = '/v1/admin';
export const workflowBuilderApi = {
    // -----------------------------------------------------------------------
    // Workflow CRUD
    // -----------------------------------------------------------------------
    createWorkflow: async (workflow) => {
        const response = await apiClient.post(`${BASE}/workflow-definitions`, workflow);
        return unwrapAndTransform(response);
    },
    updateWorkflow: async (id, workflow) => {
        const response = await apiClient.put(`${BASE}/workflow-definitions/${id}`, workflow);
        return unwrapAndTransform(response);
    },
    deleteWorkflow: async (id) => {
        await apiClient.delete(`${BASE}/workflow-definitions/${id}`);
    },
    getWorkflow: async (id) => {
        const response = await apiClient.get(`${BASE}/workflow-definitions/${id}`);
        return unwrapAndTransform(response);
    },
    listWorkflows: async () => {
        const response = await apiClient.get(`${BASE}/workflow-definitions`);
        return unwrapAndTransform(response);
    },
    // -----------------------------------------------------------------------
    // Validation
    // -----------------------------------------------------------------------
    validateWorkflow: async (id) => {
        const response = await apiClient.post(`${BASE}/workflow-definitions/${id}/validate`);
        return unwrapAndTransform(response);
    },
    // -----------------------------------------------------------------------
    // Versioning
    // -----------------------------------------------------------------------
    listVersions: async (workflowId) => {
        const response = await apiClient.get(`${BASE}/workflow-definitions/${workflowId}/versions`);
        return unwrapAndTransform(response);
    },
    getVersion: async (workflowId, version) => {
        const response = await apiClient.get(`${BASE}/workflow-definitions/${workflowId}/versions/${version}`);
        return unwrapAndTransform(response);
    },
    restoreVersion: async (workflowId, version) => {
        const response = await apiClient.post(`${BASE}/workflow-definitions/${workflowId}/versions/${version}/restore`);
        return unwrapAndTransform(response);
    },
    compareVersions: async (workflowId, v1, v2) => {
        const response = await apiClient.get(`${BASE}/workflow-definitions/${workflowId}/versions/compare`, { params: { v1, v2 } });
        return unwrapAndTransform(response);
    },
    // -----------------------------------------------------------------------
    // Deployment
    // -----------------------------------------------------------------------
    deployWorkflow: async (request) => {
        const response = await apiClient.post(`${BASE}/workflow-definitions/${request.workflowId}/deploy`, request);
        return unwrapAndTransform(response);
    },
    getDeploymentStatus: async (workflowId) => {
        const response = await apiClient.get(`${BASE}/workflow-definitions/${workflowId}/deployments`);
        return unwrapAndTransform(response);
    },
    rollbackWorkflow: async (workflowId, toVersion) => {
        const response = await apiClient.post(`${BASE}/workflow-definitions/${workflowId}/rollback`, toVersion !== undefined ? { version: toVersion } : undefined);
        return unwrapAndTransform(response);
    },
    // -----------------------------------------------------------------------
    // Testing & Replay
    // -----------------------------------------------------------------------
    testWorkflow: async (workflowId, input) => {
        const response = await apiClient.post(`${BASE}/workflow-definitions/${workflowId}/test`, { input });
        return unwrapAndTransform(response);
    },
    replayWorkflow: async (workflowId, request) => {
        const response = await apiClient.post(`${BASE}/workflow-definitions/${workflowId}/replay`, request);
        return unwrapAndTransform(response);
    },
    // -----------------------------------------------------------------------
    // Step Library
    // -----------------------------------------------------------------------
    getStepLibrary: async () => {
        const response = await apiClient.get(`${BASE}/step-library`);
        return unwrapAndTransform(response);
    },
    // -----------------------------------------------------------------------
    // Templates
    // -----------------------------------------------------------------------
    listTemplates: async () => {
        const response = await apiClient.get(`${BASE}/workflow-templates`);
        return unwrapAndTransform(response);
    },
    getTemplate: async (templateId) => {
        const response = await apiClient.get(`${BASE}/workflow-templates/${templateId}`);
        return unwrapAndTransform(response);
    },
    instantiateTemplate: async (templateId) => {
        const response = await apiClient.post(`${BASE}/workflow-templates/${templateId}/instantiate`);
        return unwrapAndTransform(response);
    },
    // -----------------------------------------------------------------------
    // Analytics
    // -----------------------------------------------------------------------
    getWorkflowAnalytics: async (workflowId, filters) => {
        const response = await apiClient.get(`${BASE}/workflow-definitions/${workflowId}/analytics`, { params: filters });
        return unwrapAndTransform(response);
    },
};
